import { render, staticRenderFns } from "./Artigos.vue?vue&type=template&id=009255a8&"
import script from "./Artigos.vue?vue&type=script&lang=js&"
export * from "./Artigos.vue?vue&type=script&lang=js&"
import style0 from "./Artigos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports